import React from 'react'

import moment from 'moment'
import _ from 'underscore'

import {Button, IconButton, SortableList, indexId, Colors, H5, S1, Card, Row} from '../UI/index.js'
import {formSpacing} from '../UI/forms/index.js'
import EditAddress from './EditAddress.js'
import dbCodes from 'server/dbCodes.js'

export default class Addresses extends React.Component {
    constructor(props) {
        super(props)
        const addressBook = JSON.parse(JSON.stringify(props.addressBook))

        const groupedByName = _.groupBy(addressBook, 'name')

        _.values(props.customers).map((customer) => {
            if (!groupedByName[customer.name]) {
                addressBook.push(customer.address)
            }
        })

        this.state = {
            addressBook
        }
    }

    onListChange(addresses) {
        const {onChange} = this.props

        if (addresses.length === 2 && addresses[0].type === 'delivery' && addresses[1].type === 'pickup') {
            addresses[0].type = 'pickup'

            addresses[1].type = 'delivery'
            addresses[1].gpsRequired = addresses[0].gpsRequired
            addresses[1].scanRequired = addresses[0].scanRequired
            addresses[1].signatureRequired = addresses[0].signatureRequired
            addresses[1].signatureNeighbors = addresses[0].signatureNeighbors
            addresses[1].statedAddressOnly = addresses[0].statedAddressOnly
            addresses[1].nameRequired = addresses[0].nameRequired
            addresses[1].imageRequired = addresses[0].imageRequired
            addresses[1].mailboxDelivery = addresses[0].mailboxDelivery
            addresses[1].refrigerated = addresses[0].refrigerated
            addresses[1].minimumAge = addresses[0].minimumAge
            addresses[1].idCheck = addresses[0].idCheck
            addresses[1].customOptions = addresses[0].customOptions

            delete addresses[0].signatureRequired
            delete addresses[0].signatureNeighbors
            delete addresses[0].statedAddressOnly
            delete addresses[0].nameRequired
            delete addresses[0].imageRequired
            delete addresses[0].mailboxDelivery
            delete addresses[0].refrigerated
            delete addresses[0].minimumAge
            delete addresses[0].idCheck
            delete addresses[0].customOptions
        }

        onChange(addresses)
    }

    onClickAddAddress() {
        const {reseller, customer, onChange, order, orderTypes} = this.props
        const addresses = [...this.props.addresses]

        let deliveryOptions = reseller.settings.orders.defaultDeliveryOptions

        if (customer.settings.orders.defaultDeliveryOptions && Array.isArray(customer.settings.orders.defaultDeliveryOptions)) {
            deliveryOptions = customer.settings.orders.defaultDeliveryOptions
        } else if (customer.settings.orders.defaultDeliveryOptions === 'none') {
            deliveryOptions = []
        }

        addresses.push({
            type: 'delivery',
            signatureRequired: deliveryOptions.includes('signatureRequired'),
            statedAddressOnly: deliveryOptions.includes('statedAddressOnly'),
            nameRequired: deliveryOptions.includes('nameRequired'),
            scanRequired: deliveryOptions.includes('scanRequired'),
            imageRequired: deliveryOptions.includes('imageRequired'),
            gpsRequired: deliveryOptions.includes('gpsRequired'),
            mailboxDelivery: deliveryOptions.includes('mailboxDelivery'),
            refrigerated: deliveryOptions.includes('refrigerated'),
            customOptions: deliveryOptions.filter((option) => !dbCodes.pickupAndDeliveryOptions[option]),
            name: '',
            attention: '',
            street: '',
            street2: '',
            postalCode: '',
            nr: '',
            addition: '',
            city: '',
            country: 'NL',
            isBusiness: false,
            instructions: '',
            email: '',
            phone: '',
            startTime: reseller.settings.account.openingHours[moment(order.date).format('dddd').toLowerCase()] ?
                reseller.settings.account.openingHours[moment(order.date).format('dddd').toLowerCase()].from :
                '00:00',
            endTime: reseller?.settings?.account?.openingHours[moment(order.date).format('dddd').toLowerCase()] && reseller.settings.account.openingHours[moment(order.date).format('dddd').toLowerCase()].till > moment().format('HH:mm') ?
                reseller.settings.account.openingHours[moment(order.date).format('dddd').toLowerCase()].till :
                '23:59'
        })

        if (orderTypes && !orderTypes.includes('multi')) {
            if (addresses.length > 1) {
                addresses[0].type = 'pickup'
                addresses[1].type = 'delivery'
            }
        }

        if (orderTypes && !orderTypes.includes('ab') && !orderTypes.includes(addresses[0].type)) {
            addresses[0].type = orderTypes.includes('pickup') ? 'pickup' : 'delivery'
        }

        onChange(addresses)
    }

    onClickRemoveAddress(index) {
        const {onChange, orderTypes} = this.props
        const addresses = [...this.props.addresses]
        addresses.splice(index, 1)

        if (orderTypes && addresses.length === 1 && !orderTypes.includes(addresses[0].type)) {
            addresses[0].type = orderTypes.includes('pickup') ? 'pickup' : 'delivery'
        }

        onChange(addresses)
    }

    onAddressChange(index, address, getPrice, timeslotFromAddressBook) {
        const {onChange} = this.props
        const addresses = [...this.props.addresses]

        const originalStartTime = addresses[index].startTime
        const originalEndTime = addresses[index].endTime

        addresses[index] = {...address}

        // A timeslot from the address book only applies to the chosen address
        addresses.map((address, addressIndex) => {
            if (addressIndex > index && !timeslotFromAddressBook) {
                if (addresses[addressIndex].startTime === originalStartTime) {
                    addresses[addressIndex].startTime = addresses[index].startTime
                }

                if (addresses[addressIndex].endTime === originalEndTime) {
                    addresses[addressIndex].endTime = addresses[index].endTime
                }
            }
        })

        onChange(addresses, getPrice)
    }

    setCustomer(value) {
        this.address.setName({target: {value}})
    }

    focus(index) {
        index = index || 0
        const element = document.getElementById(`nameaddress${index}`)
        const addresses = [...this.props.addresses]

        if (element && !addresses[index].name) {
            setTimeout(() => {
                element.focus()
            }, 10) // Timeout to prevent focus from being overwritten by the popover
        }
    }

    render() {
        const {addressBook} = this.state
        const {addresses, showAddAddressButton, showDays, availableDays, orderTypes, reseller, customer, fillTimeslot} = this.props

        return (
            <>
                <Row style={{alignItems: 'center', marginTop: 24}}>
                    <H5 style={{marginBottom: 24, flex: 1}}>Adressen</H5>
                </Row>

                <SortableList
                    dragHandle
                    getId={indexId}
                    // Block, like the list before: the items' bottom margins collapse with the spacing around it
                    style={{display: 'block'}}
                    items={addresses}
                    onChange={this.onListChange.bind(this)}
                    renderItem={(address, DragHandle, index) => {
                        return (
                            <Card style={{width: '100%', background: Colors.grey20, marginBottom: 12, padding: formSpacing.inset}}>

                                <div style={{display: 'flex', alignItems: 'center', marginBottom: 10}}>
                                    <S1 style={{flex: 1}}>{address.isBusiness && address.name ? address.name : (`${address.street} ${address.nr}${address.addition}`.trim() || `Adres ${index + 1}`)}</S1>

                                    <DragHandle />

                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flex: 1}}>
                                        {addresses.length > 1 && (addresses.length > 2 || !orderTypes || orderTypes.includes('pickup') || orderTypes.includes('delivery')) &&
                                            <IconButton onClick={this.onClickRemoveAddress.bind(this, index)}>
                                                <i className='mdi mdi-delete' />
                                            </IconButton>
                                        }
                                    </div>
                                </div>

                                <EditAddress
                                    id={`address${index}`}
                                    editAddressTypeAllowed={!orderTypes || orderTypes.includes('multi') || (orderTypes.includes('pickup') && orderTypes.includes('delivery') && addresses.length === 1)}
                                    address={address}
                                    addressBook={addressBook}
                                    showDays={showDays}
                                    availableDays={availableDays}
                                    onConfirm={this.focus.bind(this, index + 1)}
                                    onChange={this.onAddressChange.bind(this, index)}
                                    allowAttachments={true}
                                    fillTimeslot={fillTimeslot}
                                    ref={(ref) => {
                                        if (index === 0) {
                                            this.address = ref
                                        }

                                        this.addresses = this.addresses || []
                                        this.addresses[index] = ref
                                    }}
                                    reseller={reseller}
                                    customer={customer}
                                />
                            </Card>
                        )
                    }}
                />

                {showAddAddressButton && (!orderTypes || orderTypes.includes('multi') || (orderTypes.includes('ab') && addresses.length === 1)) &&
                    <div style={{display: 'flex'}}>
                        <Button
                            style={{marginBottom: 12}}
                            variant='outline-white'
                            icon='mdi mdi-plus'
                            tooltip='Nieuw adres'
                            onClick={this.onClickAddAddress.bind(this)}
                        />
                    </div>
                }
            </>
        )
    }
}
